<h2>Gestion des stocks</h2>
<div class="row">
    <div class="col-sm-2">
        <button class="btn btn-info btn-block">Articles</button>
        <button class="btn btn-info btn-block">Fabricants</button>
        <button class="btn btn-info btn-block">Fournisseurs</button>
        <button class="btn btn-info btn-block">Commandes</button>
        <button class="btn btn-info btn-block">Inventaires</button>
    </div>
    <div class="col-sm-2">
        <button class="btn btn-info btn-block">Suivi du matériel</button>
        <button class="btn btn-info btn-block">S-M-A-R</button>
    </div>
    <div class="col-sm-2">
        <button class="btn btn-info btn-block">Atelier</button>
    </div>
</div>
